import { useCurrentPurchaseOrderContractTask } from '@/providers/PurchaseOrderContractTaskProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect } from 'react';
import { ScrollTop } from '@/components/element/ScrollTop';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { TaskSummary } from '@/components/features/tasks/purchase_order_contract/TaskSummary';
import { Comments } from '@/components/features/tasks/purchase_order_contract/Comments';
import { TaskProgress } from '@/components/features/tasks/purchase_order_contract/TaskProgress';
import { TaskFiles } from '@/components/features/tasks/purchase_order_contract/TaskFiles';
import { Activities } from '@/components/features/tasks/purchase_order_contract/Activities';
import { useCurrentPurchaseOrder } from '@/providers/PurchaseOrderProvider';
import { ToDoList } from '@/components/features/tasks/purchase_order_contract/ToDoList';
import { ProjectInfo } from '@/components/features/tasks/purchase_order_contract/ProjectInfo';

export const PurchaseOrderContractTask = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  const { _w_, _t_, me, meTeamMember, isTeamAdmin, isApprover, isFinancialOfficer, isBackoffice, isMember } =
    useCurrentTeamMember();
  const { _po_ } = useCurrentPurchaseOrder();
  useEffect(() => setTitle(`契約申請（費用）タスク詳細`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        {
          label: `プロジェクト（費用） - ${_t_!.name}`,
          path: `/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders`,
        },
        {
          label: `プロジェクト（費用）詳細`,
          path: `/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders/${_po_!.id}`,
        },
      ]),
    []
  );

  const { purchaseOrderContractTask } = useCurrentPurchaseOrderContractTask();

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <div className="row mb-4">
          <div className="col-12 col-lg-7">
            <ToDoList />

            <TaskFiles />

            <Comments />
          </div>
          <div className="col-12 col-lg-5">
            <TaskSummary />

            <TaskProgress />

            <ProjectInfo />

            <Activities />
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
